const getTime = () => {
  let sessionData = {}
  try {
    sessionData = JSON.parse(sessionStorage?.getItem('timeConfig')) || {}
  } catch (e) {
    sessionData = {}
  }  
  const diff = sessionData?.diff || 0
  const newLocaltime = new Date()
  return new Date(newLocaltime.valueOf() + diff)
}

export const callGlobalData = () => {
  window.getTime = getTime
  return null
}

export const saveServerTimeDiff = (serverTimeValue) => {
  const serverTime = new Date(serverTimeValue)
  if (Number.isNaN(serverTime.valueOf())) return
  const localTime = new Date()
  const diff = serverTime.valueOf() - localTime.valueOf()
  sessionStorage.setItem('timeConfig', JSON.stringify({ serverTime, localTime, diff }))
}
